import React from 'react'
import Image from 'components/LegacyImage'
import { PricingItem } from './PricingItem'
import styles from './PricingCard.module.scss'

interface PricingCardProps {
  logo: React.ReactNode
  title: string
  subtitle: string
  startingAtLabel: string
  /** how-it-works lightens this label; the landing page tints all three. */
  startingAtTone?: 'medium' | 'tint'
  price: string
  pricePeriod: string
  features: string[]
  cta: React.ReactNode
  disclaimer: React.ReactNode
}

export const PricingCard = ({
  logo,
  title,
  subtitle,
  startingAtLabel,
  startingAtTone = 'tint',
  price,
  pricePeriod,
  features,
  cta,
  disclaimer,
}: PricingCardProps) => (
  <div
    className={`d-flex flex-column justify-content-between mc-w-100 mc-corners--md mc-gap-8 mc-p-8 mc-bg-neutral-900 ${styles.card}`}
  >
    <div>
      <div className='d-flex align-items-center mc-gap-4 mc-mb-4'>
        <div
          className={`d-flex align-items-center justify-content-center flex-shrink-0 mc-corners--sm mc-bg-neutral-800 ${styles.iconContainer}`}
        >
          {logo}
        </div>
        <div>
          <h3 className='mc-mb-1 mc-text-white mc-font-title mc-text--bold'>
            {title}
          </h3>
          <p className='mc-text-small mc-text-color--tint'>{subtitle}</p>
        </div>
      </div>
      <hr className='mc-separator mc-separator--subtle mc-my-8' />
      <div className='mc-mb-6'>
        <p className={`mc-text-small mc-text-color--${startingAtTone} mc-mb-1`}>
          {startingAtLabel}
        </p>
        <div>
          <span className='mc-text-white mc-font-headline2'>{price}</span>
          <span className='mc-text-color--tint'>{pricePeriod}</span>
        </div>
      </div>
      <ul className='mc-mt-4'>
        {features.map((feature, index) => (
          <li className='mc-mb-4' key={index}>
            <PricingItem>{feature}</PricingItem>
          </li>
        ))}
      </ul>
    </div>
    <div>
      <div className='mc-mb-4'>{cta}</div>
      <p className='mc-text-x-small mc-text-color--medium mc-text--center'>
        {disclaimer}
      </p>
    </div>
  </div>
)

/** Fills the card's icon well, which is sized for a 20px mark. */
export const PricingCardLogo = ({ src, alt }: { src: string; alt: string }) => (
  <Image src={src} width={20} height={20} alt={alt} className={styles.logo} />
)
